module.exports = __webpack_public_path__ + "static/media/LinkedIn.e6afdbc1.jpg";